"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findSpecie = exports.findBreed = void 0;
var _constants = require("../constants/constants");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Finds the breed based on the query parameter and species.
 *
 * @param {{ breeds: Array, queryBreed: string }} params
 *    - breeds: Array of available breeds.
 *    - queryBreed: The breed received from the query params, which can be either the breed code or breed name.
 * @param {string} specie - The species to which the breeds belong.
 * @returns {{breed: { description: string, breedCode: string, isCrossBreed: boolean }, specie: string} | null}
 */
var findBreed = exports.findBreed = function findBreed(_ref, specie) {
  var breeds = _ref.breeds,
    queryBreed = _ref.queryBreed;
  var breed = breeds === null || breeds === void 0 ? void 0 : breeds.find(function (b) {
    if (queryBreed) {
      return b.breedCode.toUpperCase() === queryBreed.toUpperCase() || b.description.toLowerCase().replace(/\s+/g, '') === queryBreed.toLowerCase().replace(/\s+/g, '');
    }
    return null;
  });
  return breed ? {
    breed: breed,
    specie: specie
  } : null;
};

/**
 * Finds the species details based on speciesCode
 *
 * @param {string} speciesCode
 * @returns {{ species: string, speciesCode: string}}
 */
var findSpecie = exports.findSpecie = function findSpecie(speciesCode) {
  var _codeBySpecies;
  if (!speciesCode) return {};
  var codeBySpecies = (_codeBySpecies = {}, _defineProperty(_codeBySpecies, _constants.CAT_SPECIES, _constants.CAT_SPECIES_CODE), _defineProperty(_codeBySpecies, _constants.DOG_SPECIES, _constants.DOG_SPECIES_CODE), _codeBySpecies);
  var species = Object.keys(codeBySpecies).find(function (key) {
    return speciesCode && codeBySpecies[key] === speciesCode.toUpperCase();
  });
  return {
    species: species,
    speciesCode: speciesCode.toUpperCase()
  };
};